<script setup>
/* global axios */
// Icerik > Onaylar: durum='onay_bekliyor' gonderiler.
//
// Liste govdesi IcerikListe; burada yalnizca satir sonuna Onayla / Reddet
// dugmeleri ekleniyor. Listeyi ikinci kez yazmak, satirlarda yapilan her
// duzeltmeyi iki yerde tekrarlamak demekti.
//
// YETKI: onay ve red YALNIZCA yoneticide - onay akisinin tek anlami bu.
// Temsilci ekrani gorur (kendi gonderisinin sirada oldugunu bilmeli) ama
// dugmeleri gormez. Sunucu da ayni kurali uyguluyor; dugmeyi gosterip 401
// aldirmak, calismayan bir ozelligi varmis gibi gostermek olurdu.
//
// Ham 'axios' PAKETINI ice aktarmiyoruz. Chatwoot kimlik basliklarini
// window.axios uzerinde tutuyor; paketten gelen ornek 401 doner.
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import { useAdmin } from 'dashboard/composables/useAdmin';
import { useAlert } from 'dashboard/composables';
import Button from 'dashboard/components-next/button/Button.vue';
import IcerikListe from './IcerikListe.vue';
import { hataMetniniCoz } from './icerik-ortak';

const { t } = useI18n();
const route = useRoute();
const { isAdmin } = useAdmin();

const uc = computed(
  () => `/api/v1/accounts/${route.params.accountId}/icerik`
);

// Uzerinde islem suren gonderinin kimligi: ayni dugmeye iki kez basilmasin.
const islemdeki = ref(null);

// Red sebebi acik olan gonderinin kimligi ve metni.
//
// NEDEN window.prompt degil: sebep hazirlayana geri donen ve gonderide kalici
// olarak duran bir metin. Tarayicinin tek satirlik kutusu uzun bir gerekceyi
// yazdirmiyor ve yazilani gostermeden gonderiyor.
const redAcik = ref(null);
const redSebebi = ref('');

const rediAc = gonderi => {
  redAcik.value = gonderi.id;
  redSebebi.value = '';
};

const rediKapat = () => {
  redAcik.value = null;
  redSebebi.value = '';
};

const onayla = async (gonderi, yenile) => {
  islemdeki.value = gonderi.id;
  try {
    await axios.post(`${uc.value}/${gonderi.id}/onayla`);
    // Onaydan sonra sunucu gonderiyi ya planliyor ya da hemen yayinliyor;
    // ikisinde de gonderi bu listeden cikar. Tek bir mesaj yaziyoruz, hangi
    // yolun secildigi gonderinin kendi durumunda gorunuyor.
    useAlert(t('ICERIK.ONAYLANDI'));
    rediKapat();
    await yenile();
  } catch (e) {
    useAlert(hataMetniniCoz(e, t('ICERIK.HATA_BILINMEYEN')));
  } finally {
    islemdeki.value = null;
  }
};

const reddet = async (gonderi, yenile) => {
  const sebep = redSebebi.value.trim();
  // Sunucu da bos sebebi reddediyor; burada durdurmak kullaniciya bos bir
  // istek atip hata beklemekten hizli.
  if (!sebep) {
    useAlert(t('ICERIK.RED_SEBEBI_ZORUNLU'));
    return;
  }

  islemdeki.value = gonderi.id;
  try {
    await axios.post(`${uc.value}/${gonderi.id}/reddet`, { sebep });
    useAlert(t('ICERIK.REDDEDILDI'));
    rediKapat();
    await yenile();
  } catch (e) {
    useAlert(hataMetniniCoz(e, t('ICERIK.HATA_BILINMEYEN')));
  } finally {
    islemdeki.value = null;
  }
};
</script>

<template>
  <div class="flex flex-col">
    <!-- Temsilciye neden dugme gormedigini soyluyoruz. Aciklamasiz eksik bir
         dugme "bozuk" hissettiriyor. -->
    <p v-if="!isAdmin" class="px-6 pt-6 -mb-2 text-xs text-n-slate-11">
      {{ t('ICERIK.ONAY_TEMSILCI') }}
    </p>

    <IcerikListe sabit-durum="onay_bekliyor" kip="onay">
      <template #satirIslemleri="{ gonderi, yenile }">
        <template v-if="isAdmin">
          <Button
            size="xs"
            variant="solid"
            :label="t('ICERIK.ONAYLA')"
            icon="i-lucide-check"
            :is-loading="islemdeki === gonderi.id && redAcik !== gonderi.id"
            :disabled="islemdeki === gonderi.id"
            @click="onayla(gonderi, yenile)"
          />
          <Button
            v-if="redAcik !== gonderi.id"
            size="xs"
            variant="faded"
            color="ruby"
            :label="t('ICERIK.REDDET')"
            icon="i-lucide-x"
            :disabled="islemdeki === gonderi.id"
            @click="rediAc(gonderi)"
          />

          <!-- w-full: esnek satirda kendi satirina insin, dugmelerin arasina
               sikismasin. -->
          <div
            v-if="redAcik === gonderi.id"
            class="flex flex-col w-full gap-2 p-3 rounded-md bg-n-alpha-1"
          >
            <label class="flex flex-col gap-1">
              <span class="text-xs text-n-slate-11">
                {{ t('ICERIK.RED_SEBEBI_ETIKET') }}
              </span>
              <textarea
                v-model="redSebebi"
                rows="2"
                class="px-2 py-1.5 text-sm border rounded-md resize-y border-n-weak bg-n-solid-1 text-n-slate-12"
                :placeholder="t('ICERIK.RED_SEBEBI_YER')"
              />
            </label>
            <p class="text-xs text-n-slate-11">
              {{ t('ICERIK.RED_ACIKLAMA') }}
            </p>
            <div class="flex gap-2">
              <Button
                size="xs"
                variant="solid"
                color="ruby"
                :label="t('ICERIK.REDDET')"
                :is-loading="islemdeki === gonderi.id"
                :disabled="islemdeki === gonderi.id"
                @click="reddet(gonderi, yenile)"
              />
              <Button
                size="xs"
                variant="ghost"
                color="slate"
                :label="t('ICERIK.VAZGEC')"
                :disabled="islemdeki === gonderi.id"
                @click="rediKapat"
              />
            </div>
          </div>
        </template>
      </template>
    </IcerikListe>
  </div>
</template>
